export class EngineNumber {
	id: number;
	name: string;
	displayOrder: number;
}
